import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import BannerFieldCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/BannerFieldCardFragment/BannerFieldCardFragment";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";

function BannerFieldCardFragmentDemo() {
  const [value, setValue] = useState("Example banner field text");

  const task = { details: { text: value } } as unknown as Task;

  return (
    <Demo>
      <Name>BannerFieldCardFragment</Name>
      <Highlight>
        <BannerFieldCardFragment
          configProps={{ field: "details.text" }}
          commonProps={{ task }}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="value"
          type="text"
          id="bannerfieldfragmentdemo-value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(BannerFieldCardFragmentDemo);
